import { GtagViewSearchResults } from '~/modules/aatrium-gtm'
import { event } from '~/modules/aatrium-gtm/helpers'

export function sendGtagViewSearchResultEvent (params: GtagViewSearchResults): void {
  event('view_search_results', params)
}
